import React from 'react';
import { Trans } from 'react-i18next';

import { getSubscriptionTitle } from '../helpers';

import { Text } from 'components/library';

import * as S from './styled';

import { IFeePriceRow } from '../types';

const FeePriceRow = ({ period, price, pricePerState, periodPerState }: IFeePriceRow) => {
    const paymentLabel = getSubscriptionTitle(period, false);
    const perStateLabel = getSubscriptionTitle(periodPerState, false);

    return (
        <S.PriceRow>
            <Text type="medium-text">
                <Trans
                    i18nKey="subscription.commitment.period"
                    values={{ count: paymentLabel?.count, context: paymentLabel?.context }}
                />
            </Text>
            <Text type="medium-text" className="text-right">
                {price}
                {pricePerState && (
                    <S.NotWrapBox>
                        <Trans
                            i18nKey="subscription.commitment.feePrice"
                            values={{
                                count: perStateLabel?.count,
                                context: perStateLabel?.context,
                                price: pricePerState,
                            }}
                        />
                    </S.NotWrapBox>
                )}
            </Text>
        </S.PriceRow>
    );
};

export default FeePriceRow;
